export const validateApplication = (formData, resume) => {

    const errors = {};

    // ==========================
    // Personal Information
    // ==========================

    if (!formData.fullName.trim()) {
        errors.fullName = "Full name is required.";
    } else if (formData.fullName.trim().length < 3) {
        errors.fullName = "Full name must be at least 3 characters.";
    }

    if (!formData.mobile.trim()) {
        errors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
        errors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (!formData.email.trim()) {
        errors.email = "Email address is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
        errors.email = "Enter a valid email address.";
    }

    if (!formData.dob) {
        errors.dob = "Date of birth is required.";
    } else {
        const today = new Date();
        const dob = new Date(formData.dob);

        if (dob > today) {
            errors.dob = "Date of birth cannot be in the future.";
        }
    }

    if (!formData.gender) {
        errors.gender = "Please select your gender.";
    }

    // ==========================
    // Address
    // ==========================

    if (!formData.address.trim()) {
        errors.address = "Address is required.";
    }

    if (!formData.city.trim()) {
        errors.city = "City is required.";
    }

    if (!formData.state) {
        errors.state = "Please select your state.";
    }

    if (!formData.pincode.trim()) {
        errors.pincode = "Pincode is required.";
    } else if (!/^\d{6}$/.test(formData.pincode)) {
        errors.pincode = "Enter a valid 6-digit pincode.";
    }

    // ==========================
    // Education
    // ==========================

    if (!formData.college.trim()) {
        errors.college = "College name is required.";
    }

    if (!formData.course.trim()) {
        errors.course = "Course name is required.";
    }

    if (!formData.educationLevel) {
        errors.educationLevel = "Please select your education level.";
    }

    // ==========================
    // Internship Details
    // ==========================

    if (!formData.domain) {
        errors.domain = "Please select your preferred domain.";
    }

    if (!formData.duration) {
        errors.duration = "Please select internship duration.";
    }

    if (!formData.previousExperience) {
        errors.previousExperience = "Please select your experience.";
    }

    if (!formData.whyJoin.trim()) {
        errors.whyJoin = "Please tell us why you want to join HORYZEN.";
    } else if (formData.whyJoin.trim().length < 20) {
        errors.whyJoin = "Please write at least 20 characters.";
    }

    // ==========================
    // Contact Preference
    // ==========================

    if (!formData.contactMethod) {
        errors.contactMethod = "Please select a contact method.";
    }

    if (!formData.hearAbout) {
        errors.hearAbout = "Please tell us how you heard about us.";
    }

    // ==========================
    // TPO Details
    // ==========================

    if (!formData.tpoName.trim()) {
        errors.tpoName = "TPO name is required.";
    }

    if (!formData.tpoContact.trim()) {
        errors.tpoContact = "TPO contact number is required.";
    } else if (!/^[6-9]\d{9}$/.test(formData.tpoContact)) {
        errors.tpoContact = "Enter a valid 10-digit mobile number.";
    }

    if (!formData.tpoEmail.trim()) {
        errors.tpoEmail = "TPO email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.tpoEmail)) {
        errors.tpoEmail = "Enter a valid email address.";
    }

    // ==========================
    // Resume
    // ==========================

    if (!resume) {

        errors.resume = "Please upload your resume.";

    } else {

        const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ];

        if (!allowedTypes.includes(resume.type)) {
            errors.resume = "Only PDF, DOC and DOCX files are allowed.";
        }

        const maxSize = 10 * 1024 * 1024;

        if (resume.size > maxSize) {
            errors.resume = "Resume size must not exceed 10 MB.";
        }

    }

    // ==========================
    // Declaration
    // ==========================

    if (!formData.declaration) {
        errors.declaration = "Please accept the declaration.";
    }

    return {

        isValid: Object.keys(errors).length === 0,

        errors

    };

};